import styled from 'styled-components';
import { BLUE } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StyledLinkButton = (styled.div`
  cursor: pointer;
  color: ${BLUE};
  text-decoration: underline;
  font-family: ${INTER.medium};
  font-size: 14px;
  padding: 16px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
